import { computed } from 'mobx';
import { BaseUserStore } from './base-user.store';
import { IUserResponse } from '~/types/server.types';
import { PartialWithRequired } from '~/types/app.types';

export class UserStore extends BaseUserStore {
    @computed
    get currUser() {
        return this.byId(this.globalContext.sessionStore.currUserId);
    }

    /**
     * WARNING: This function updates only the react user store, changes may not be saved when navigating to another page. consider using userCtrl.updateUser instead.
     * explanation: whenever we're mounting any react root (e.g. navigating between pages), we're setting the the angular user into the react user even though there might have been a mutation on the react side and the react user is actually more up-to-date.
     * see https://honeybook.slack.com/archives/C0C3JRVGD/p1702474017736329
     */
    update(item: PartialWithRequired<IUserResponse, '_id'>) {
        return super.update(item);
    }
}
